import { render, staticRenderFns } from "./ExpansionPanels.vue?vue&type=template&id=8fe4f310"
import script from "./ExpansionPanels.vue?vue&type=script&lang=js"
export * from "./ExpansionPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports